/** @format */

import React, { FunctionComponent, ReactElement, useEffect, useState } from 'react';
import SimCardInterface from '../../../interfaces/platform/SimCardInterface';
import { ItemLoaders } from '../../../core/loaders/ItemLoaders';
import { useDispatch } from 'react-redux';
import CustomTextButtom from '../../../components/Buttons/CustomTextButton';
import { ProductChangeProfileChoose } from './ProductChangeProfileChoose';
import { FormGeneralHelper } from '../../../helpers/FormGeneral';
import AlertInfo from '../../../components/Info/AlertInfo';
import { ProductActions } from '../../../modules/simcard/ProductReducer';

type ProductChangeProfileType = {
    product: SimCardInterface;
    reload(): void;
    classes: any;
};

export const ProductChangeProfile: FunctionComponent<ProductChangeProfileType> = ({ product, reload }): ReactElement => {
    const dispatch = useDispatch();
    const [changeProfileOpen, setChangeProfileOpen] = useState(false);
    const [alert, setAlert] = useState<any | null>(null);

    const removeChangeProfile = (): void => {
        const itemLoader = new ItemLoaders(dispatch);
        const params = {
            activationType: 8,
            id: product.id,
            params: JSON.stringify({
                profileChangeDelete: true,
            }),
        };
        itemLoader.putWithCallback(
            FormGeneralHelper.getUrl('/operation_on_sim_cards/' + product.id),
            'operation_on_sim_cards',
            params,
            (response: any) => {
                setAlert(null);
                dispatch({
                    type: ProductActions.PRODUCT_REFRESH_VIEW,
                    uri: product['@id'],
                });
            },
            { propagateDataToCallback: true, dispatchAfterCallback: false }
        );
    };

    const removeChangeProfileConfirm = (): void => {
        setAlert(
            <AlertInfo
                onConfirm={removeChangeProfile}
                onCancel={(): void => setAlert(null)}
                confirmBtnText={'simcard:f.save_change'}
                cancelBtnText={'general:common.cancel'}
                content={'simcard:v.profile_change_remove'}
            />
        );
    };

    return (
        <>
            {product.profilePlannedChangeDate === null && (
                <CustomTextButtom
                    callback={(): void => setChangeProfileOpen(true)}
                    callbackParam={{}}
                    label={'simcard:v.button_change_profile'}
                    size="sm"
                />
            )}
            {product.profilePlannedChangeDate !== null && (
                <CustomTextButtom
                    callback={removeChangeProfileConfirm}
                    callbackParam={{}}
                    label={'simcard:v.button_remove_change_profile'}
                    size="sm"
                />
            )}
            <ProductChangeProfileChoose
                open={changeProfileOpen}
                close={(): void => {
                    setChangeProfileOpen(false);
                }}
                product={product}
                reload={reload}
            />
            {alert}
        </>
    );
};
